export const isPathPermitted = (user, pathname = "") => {
  if (!user) {
    return false;
  }

  const pathArray = pathname.split("/").filter(Boolean);
  const section = pathArray[1];
  const subPath = pathArray[2];

  if (section === "financial-requests") {
    if (subPath === "agency-discounted-prices") {
      return !!user.permissions?.[section]?.["view-agency-discounted-prices"];
    }
    return !!user.permissions?.[section]?.["view-all"];
  }

  if (section === "reports") {
    return true;
  }

  return true;
};
